import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Text,
    View,
    TouchableOpacity,
    Image,
    ScrollView,
    Button
} from 'react-native'

import { push } from 'react-router-redux'
import styles from './styles'
import { stateGetInToJS, getAvatar } from '../../lib/index'

import CONSTANTS from '../../constants/constants'
import MainReducer from '../../containers/main/reducer'

class Profile extends Component {
    static NAME = 'Profile'

    componentDidMount() {
        this.props.fetchProfile(true)
        this.props.fetchEndpoints()
        this.props.fetchIdentities()
    }

    renderIdentities(
        currentIdentity,
        identities,
        userSettings
    ) {
        if (null === identities || 0 >= identities.length || !currentIdentity || !userSettings) return null;

        return identities
            .filter((identity) => {
                return (userSettings.carrotUser || userSettings.adminOverride)
                    ? (identity.id !== currentIdentity.id)
                    : (identity.id !== currentIdentity.id) &&
                        (CONSTANTS.USER_TYPES.SUPERUSER === identity.identity_type ||
                        CONSTANTS.USER_TYPES.ESTABLISHMENT === identity.identity_type)
                // return (identity.id !== currentIdentity.id) &&
                //         (CONSTANTS.USER_TYPES.SUPERUSER === identity.identity_type ||
                //         CONSTANTS.USER_TYPES.ESTABLISHMENT === identity.identity_type)
            })
            .map((identity, index) => {

            let currentIdentityBadge = getAvatar(identity)

            return (
                <TouchableOpacity
                    key={index}
                    onPress={this.props.switchCurrentIdentity.bind(this, identity)}
                    activeOpacity={0.8}>

                    <View style={styles.switcherBadge} >
                        <View style={[currentIdentityBadge.badgeStyle, styles.switcherBadgeView]}>
                            <Image style={styles.switcherBadgeImg}
                                source={currentIdentityBadge.badgeImage} />
                        </View>
                        <Text style={styles.switcherBadgeText} numberOfLines={1}>
                            {identity.name}
                        </Text>
                    </View>

                </TouchableOpacity>
            )
        })
    }

    render() {
        const { user, streetAddr, admin, onClose, ...props } = this.props
        const currentIdentityBadge = getAvatar(user.currentIdentity)

        return (
            <View style={styles.container}>
                <View style={styles.version}>
                    <Text style={styles.versionText}>
                        v{CONSTANTS.VERSION_NUMBER}
                    </Text>
                </View>

                {admin && <View style={{ position: 'absolute', top: 20, left: 20 }}>
                    <Button
                        title="Listboard"
                        color="purple"
                        onPress={() => {
                            onClose()
                            this.props.goListboard()
                        }} />

                    <Button
                        title="Dashboard"
                        color="green"
                        onPress={() => {
                            onClose()
                            this.props.goDashboard()
                        }} />
                </View>}

                <TouchableOpacity
                    style={styles.close}
                    activeOpacity={0.8}
                    onPress={onClose.bind(this)}>
                        <Image style={{width: 30, height: 30}}
                            source={require('../../images/close_gray.png')} />
                </TouchableOpacity>

                <View style={styles.badge}>
                    <TouchableOpacity
                        style={[currentIdentityBadge.badgeStyle, styles.badgeView]}
                        onPress={() => {}}
                        activeOpacity={1}>
                            <Image style={styles.badgeImg}
                                source={currentIdentityBadge.badgeImage} />

                            {/*<View style={styles.avatarEdit}>
                                <Image style={{width: 57, height: 17}}
                                    source={require('../../images/avatar_edit.png')} />
                            </View>*/}
                    </TouchableOpacity>

                    <View style={{
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Text style={styles.badgeText}>
                            {user.currentIdentity && user.currentIdentity.name
                                ? user.currentIdentity.name
                                : 'Meet Carrot Merchant'}
                        </Text>

                        {streetAddr && streetAddr.value && <Text style={styles.street}>
                            {streetAddr.value}
                        </Text>}
                    </View>
                </View>

                <View style={styles.switcher}>
                    <ScrollView
                        contentContainerStyle={{ justifyContent: 'flex-end' }}
                        horizontal={false}>

                        {this.renderIdentities(user.currentIdentity, user.identities, user.userSettings)}
                    </ScrollView>

                    <TouchableOpacity
                        onPress={props.logout.bind(this)}
                        activeOpacity={0.8}>

                        <View style={styles.switcherBadge} >
                            <View style={styles.logoutView}>
                                <Image style={styles.logoutImg}
                                    source={require('../../images/logout.png')} />
                            </View>

                            <Text style={styles.switcherBadgeText} numberOfLines={1}>
                                LOGOUT
                            </Text>
                        </View>
                    </TouchableOpacity>
                </View>
            </View>
        )
    }
}

const mapStateToProps = (state) => ({
    user: stateGetInToJS(state, MainReducer.NAME, ['user'], 'Profile')
})

const mapDispatchToProps = (dispatch) => ({
    logout: () => {
        dispatch(MainReducer.logout())
    },
    fetchProfile: (refresh) => {
        dispatch(MainReducer.fetchProfile(refresh))
    },
    fetchEndpoints: () =>{
        dispatch(MainReducer.fetchEndpoints())
    },
    fetchIdentities: () => {
        dispatch(MainReducer.fetchIdentities())
    },
    switchCurrentIdentity: (identity) => {
        dispatch(MainReducer.switchCurrentIdentity(identity))
    },
    goListboard: () => {
        dispatch(push('/'))
    },
    goDashboard: () => {
        dispatch(push('/dashboard'))
    }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
        admin: stateProps.user && stateProps.user.userSettings &&
                (stateProps.user.userSettings.carrotUser || stateProps.user.userSettings.adminOverride),
        streetAddr: stateProps.user && stateProps.user.endpoints &&
            stateProps.user.endpoints.find((endpoint) => CONSTANTS.ENDPOINT_TYPES.ADDRESS === endpoint.endpoint_type)
    })
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Profile)



// WEBPACK FOOTER //
// ./src/components/profile/index.js